<template>
    
    <div class="profile__container" v-if="profileDataLoaded">

        <div class="profile__container__data">


            <div class="profile__container__data__profile-image"
            v-if="profileDataLoaded"
            >

                <div class="profile__container__data__profile-image__image profile__container__data__profile-image__image--empty"
                :style="{ backgroundImage: `url(${userPlaceholderImage})` }"
                v-if="profileData.profilePicture.image == null"
                ></div>

                <div class="profile__container__data__profile-image__image profile__container__data__profile-image__image--set"
                :style="{ backgroundImage: `url(${getFile(profileData.profilePicture.image,'user')})` }"
                v-if="profileData.profilePicture.image != null"
                ></div>

                <div class="profile__container__data__profile-image__action"
                v-if="profileData.profilePicture.image == null"
                @click="showPictureModal = true"
                >Subir foto de perfil</div>

                <div class="profile__container__data__profile-image__action"
                v-if="profileData.profilePicture.image != null"
                @click="showPictureModal = true"
                >Editar foto de perfil</div>
            </div>


            <Modal :isOpen="showPictureModal" @close="showPictureModal = false">
                <div class="profile__container__data__profile-image__modal">
                    <h4>Subir foto de perfil</h4>
                    <UploadFileDrag
                        :currentFile="profileImageURL"
                        containerCDN="user"
                        @fileUploaded="fileCDN => fileUploaded(fileCDN)"
                        @fileDeleted="deleteImagePreview()"
                    />
                    
                    <div class="modal__buttons">
                        <button class="cancel" @click="showPictureModal = false">Cancelar</button>
                        <button class="confirm" @click="saveProfilePicture">Guardar</button>
                    </div>
                </div>
            </Modal>


            <div class="profile__container__data__profile-nav">
                <ul class="profile__container__data__profile-nav__navigation">
                    <li class="profile__container__data__profile-nav__navigation__item"
                    :class="{'profile__container__data__profile-nav__navigation__item--selected': selectedData == 'personalData'}"
                    @click="selectedData = 'personalData';disableAllEdits()"
                    >Datos personales</li>
                    <li class="profile__container__data__profile-nav__navigation__item"
                    :class="{'profile__container__data__profile-nav__navigation__item--selected': selectedData == 'contactData'}"
                    @click="selectedData = 'contactData';disableAllEdits()"
                    >Datos de contacto</li>
                    <li class="profile__container__data__profile-nav__navigation__item"
                    :class="{'profile__container__data__profile-nav__navigation__item--selected': selectedData == 'professionalData'}"
                    @click="selectedData = 'professionalData';disableAllEdits()"
                    >Datos profesionales</li>
                </ul>
            </div>
        </div>

        <div class="profile__container__info">
            <template class="profile__container__info--personaldata" v-if="selectedData == 'personalData'">
                <div class="profile__container__info__title">
                    <h2>Datos personales</h2>
                    <span
                    @click="toggleEditPersonal"
                    v-if="!isEditingPersonal"
                    >Editar <i class="material-icons">edit</i></span>
                </div>
    
                <div class="profile__container__info__filled"
                v-if="!isEditingPersonal"
                >
                    <div>
                        <h3>Nombre</h3>
                        <span>
                            <span>{{ profileData.personalData.firstName || '-' }}</span>
                        </span>
                    </div>
                    <div>
                        <h3>Apellido</h3>
                        <span>
                            <span>{{ profileData.personalData.lastName || '-' }}</span>
                        </span>
                    </div>
                    <div>
                        <h3>Documento de identidad</h3>
                        <span>
                            <span>{{ profileData.personalData.dni || '-' }}</span>
                        </span>
                    </div>
                    <div>
                        <h3>País</h3>
                        <span>
                            <span>{{ profileData.personalData.country?.name || '-' }}</span>
                        </span>
                    </div>
                    <div>
                        <h3>Fecha de nacimiento</h3>
                        <span>
                            <span>{{ profileData.personalData.birthDate ? formatDate(profileData.personalData.birthDate) : '-' }}</span>
                        </span>
                    </div>
                    <div>
                        <h3>Género</h3>
                        <span>
                            <span>{{ profileData.personalData.gender?.name || '-' }}</span>
                        </span>
                    </div>
            </div>

                <form class="profile__container__info__form" @submit.prevent="submitPersonalDataForm"
                v-if="isEditingPersonal"
                >
                    <Input 
                        v-model="profileData.personalData.firstName"
                        type="text"
                        placeholder="Nombre"
                        label="Nombre"
                        :isError="!profileData.personalData.firstName"
                        :errorMessage="!profileData.personalData.firstName ? 'Campo requerido' : ''"
                    />
                    <Input 
                        v-model="profileData.personalData.lastName"
                        type="text"
                        placeholder="Apellido"
                        label="Apellido"
                        :isError="!profileData.personalData.lastName"
                        :errorMessage="!profileData.personalData.lastName ? 'Campo requerido' : ''"
                    />
                    <Input 
                        v-model="profileData.personalData.dni"
                        type="text"
                        placeholder="Documento de identidad"
                        label="Documento de identidad"
                        :isError="dniMaxCharacters"
                        :errorMessage="dniMaxCharacters ? 'Máximo 40 caracteres' : ''"
                        @input="checkDniCharacters"
                    />
                    <Select
                        v-model="selectedCountryId"
                        mode="simple"
                        id="selectCountry"
                        label="País"
                        valueProp="id"
                        valueLabel="name"
                        :values="country"
                        :isDropdown="true"
                    />
                    <DatePicker 
                        v-model="profileData.personalData.birthDate"
                        placeholder="Fecha de nacimiento"
                        label="Fecha de nacimiento"
                        :to="new Date()"
                    />
                    <div class="profile__container__info__form__radio">
                        <h3>Género</h3>
                        <div v-for="(gen, index) in gender" :key="index">
                            <input type="radio" :id="gen.id" v-model="selectedGenderId" :value="gen.id">
                            <label :for="gen.id">{{ gen.name }}</label>
                        </div>
                    </div>
                    <div class="buttons">
                        <button class="cancel" type="button"
                        @click="toggleEditPersonal"
                        >Cancelar</button>
                        <button class="confirm" type="submit" :disabled="!profileData.personalData.firstName || !profileData.personalData.lastName">Guardar</button>
                    </div>
                </form>

            </template>


            <template class="profile__container__info--personaldata" v-if="selectedData == 'contactData'">
                <div class="profile__container__info__title">
                    <h2>Datos de contacto</h2>
                    <span
                    @click="toggleEditContact"
                    v-if="!isEditingContact"
                    >Editar <i class="material-icons">edit</i></span>
                </div>
    
                <div class="profile__container__info__filled"
                v-if="!isEditingContact"
                >
                    <div>
                        <h3>Mail</h3>
                        <span>
                            <span>{{ profileData.contactData.email || '-' }}</span>
                        </span>
                    </div>
                    <div>
                        <h3>Telefono</h3>
                        <span>
                            <span>{{ profileData.contactData.phoneNumber || '-' }}</span>
                        </span>
                    </div>
                    <!-- <div>
                        <h3>Localidad</h3>
                        <span>
                            {{ profileData.contactData.state.name ? profileData.contactData.state.name : '-' }}
                        </span>
                    </div> -->
            </div>

                <form class="profile__container__info__form" @submit.prevent="submitContactDataForm"
                v-if="isEditingContact"
                >
                    <div class="profile__container__info__filled"
                    >
                        <div>
                            <h3>Mail</h3>
                            <span>
                                <span>{{ profileData.contactData.email || '-' }}</span>
                            </span>
                        </div>
                    </div>
                    <Input 
                        v-model="profileData.contactData.phoneNumber"
                        type="text"
                        placeholder="Número de Teléfono"
                        label="Teléfono"
                        :isError="phoneMaxCharacters"
                        :errorMessage="phoneMaxCharacters ? 'Máximo 40 caracteres' : ''"
                        @input="checkPhoneCharacters"
                    />
                    <!-- <Select
                        v-model="selectedStateId"
                        mode="simple"
                        id="selectState"
                        label="Localidad"
                        valueProp="id"
                        valueLabel="name"
                        :values="state"
                        :isDropdown="true"
                    /> -->
                    <div class="buttons">
                        <button class="cancel" type="button"
                        @click="toggleEditContact"
                        >Cancelar</button>
                        <button class="confirm" type="submit">Guardar</button>
                    </div>
                </form>

            </template>


            <template class="profile__container__info--professionaldata" v-if="selectedData == 'professionalData'">
                <div class="profile__container__info__title">
                    <h2>Datos profesionales</h2>
                    <span
                    @click="toggleEditProfessional"
                    v-if="!isEditingProfessional"
                    >Editar <i class="material-icons">edit</i></span>
                </div>
    
                <div class="profile__container__info__filled"
                v-if="!isEditingProfessional"
                >
                    <div>
                        <h3>Tipo de institución</h3>
                        <span>
                            <span>{{ profileData.professionalData.instituteType?.name ? instituteTypeMapping[profileData.professionalData.instituteType.name] : '-' }}</span>
                        </span>
                    </div>
                    <div>
                        <h3>Cantidad de alumnos en el último año</h3>
                        <span>
                            <span>{{ profileData.professionalData.studentsQuantity || '-' }}</span>
                        </span>
                    </div>
                    <div>
                        <h3>Edades de tus alumnos</h3>
                        <span>
                            <span>{{ profileData.professionalData.studentAgeRange?.name ? studentAgeRangeMapping[profileData.professionalData.studentAgeRange.name] : '-' }}</span>
                        </span>
                    </div>
                </div>

                <form class="profile__container__info__form" @submit.prevent="submitProfessionalDataForm"
                v-if="isEditingProfessional"
                >
                    <div class="profile__container__info__form__radio">
                        <h3>Tipo de institución</h3>
                        <div v-for="(type, index) in instituteType" :key="index">
                            <input type="radio" :id="type.id" v-model="selectedInstituteTypeId" :value="type.id">
                            <label :for="type.id">{{ type.name }}</label>
                        </div>
                    </div>

                    <div class="profile__container__info__form__selects">
                        <Input 
                            v-model="profileData.professionalData.studentsQuantity"
                            type="number"
                            placeholder="Cantidad de alumnos"
                            label="Cantidad de alumnos"
                            supportText="Recuerda considerar todos los cursos que tengas a cargo"
                        />
                        <Select 
                            mode="simple"
                            label="Edades de tus alumnos"
                            id="selectStudentAgeRange"
                            valueProp="id"
                            valueLabel="name"
                            :values="studentAgeRange"
                            v-model="selectedstudentAgeRangeId"
                            :isDropdown="true"
                        />
                    </div>

                    <div class="buttons">
                        <button class="cancel" type="button"
                        @click="toggleEditProfessional"
                        >Cancelar</button>
                        <button class="confirm" type="submit">Guardar</button>
                    </div>
                </form>
            </template>
        </div>
    </div><!-- /main-container -->

    <div v-else>
        <Loader />
    </div>
    
</template>

<script>

import { onMounted, ref, inject } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Input from '@/components/Input.vue';
import Select from '@/components/Inputs/Select.vue';
import DatePicker from '../components/Inputs/DatePicker.vue';
import persistentData from '@/plugins/persistentData';
import Loader from '@/components/Loader.vue';
import moment from 'moment-timezone';
import Modal from '@/components/Modal.vue';
import UploadFileDrag from '@/components/UploadFileDrag.vue';
import userPlaceholderImage from '@/assets/user.png';



export default {
    components: {
        Input,
        Select,
        DatePicker,
        Loader,
        Modal,
        UploadFileDrag
    },
    setup() {


        const getFile = inject("getFile");
        
        const store = useStore();
        const router = useRouter();
        const formatDate = date => moment(date).format('DD/MM/YYYY');

        const user = store.getters.manageUser_user;
        if (user.role.toLowerCase() !== 'learninguser') {
           router.push({ path: '/' }); // Redirect to the home page
        }



        const userData = JSON.parse(persistentData.get('user'));
        const userId = userData.id;



        const selectedData = ref('personalData');


        const creationOptions = ref();

        const profileData = ref();
        const profileDataLoaded = ref(false);


        const studentAgeRange = ref([])

        const country = ref([])

        const state = ref([])

        const instituteType = ref([])

        const gender = ref([])


        const dniMaxCharacters = ref(false);
        const checkDniCharacters = () => {
            if (profileData.value.personalData.dni && profileData.value.personalData.dni.length > 40) {
                dniMaxCharacters.value = true;
                profileData.value.personalData.dni = profileData.value.personalData.dni.slice(0, 40);
            } else {
                dniMaxCharacters.value = false;
            }
        };
        const phoneMaxCharacters = ref(false);
        const checkPhoneCharacters = () => {
            if (profileData.value.contactData.phoneNumber && profileData.value.contactData.phoneNumber.length > 40) {
                phoneMaxCharacters.value = true;
                profileData.value.contactData.phoneNumber = profileData.value.contactData.phoneNumber.slice(0, 40);
            } else {
                phoneMaxCharacters.value = false;
            }
        };


        const profileImageURL = ref('');
        const profileImageSet = ref(false);
        const showPictureModal = ref(false);

        const fileUploaded = (fileCDN) => {
            profileImageURL.value = fileCDN.split('/').pop();
        };

        const deleteImagePreview = () => {
            profileImageURL.value = '';
        };

        const saveProfilePicture = async () => {
            try {
                const payload = {
                    image: profileImageURL.value
                }
                await store.dispatch("profile_profilePicture", { userId, payload});
                showPictureModal.value = false;
                persistentData.set('user', JSON.stringify({...userData, picture: profileImageURL.value}));
                window.location.reload();
            } catch (error) {
                console.error(error);
            }
        };




        const isEditingPersonal = ref(false);
        const isEditingContact = ref(false);
        const isEditingProfessional = ref(false);


        const toggleEditPersonal = () => {
            isEditingPersonal.value = !isEditingPersonal.value;
        };

        const toggleEditContact = () => {
            isEditingContact.value = !isEditingContact.value;
        };

        const toggleEditProfessional = () => {
            isEditingProfessional.value = !isEditingProfessional.value;
        };

        const disableAllEdits = () => {
            isEditingPersonal.value = false;
            isEditingContact.value = false;
            isEditingProfessional.value = false;
            getProfile()
        };





        


        const instituteTypeMapping = {
            'PRIVATE': 'Privada',
            'PUBLIC': 'Pública',
            'MIX': 'Ambas (Pública / Privada)'
        };

        const translateInstituteTypes = (types) => {
            return types.map(type => ({
                id: type.id,
                name: instituteTypeMapping[type.name] || type.name
            }));
        };


        const studentAgeRangeMapping = {
            'LESS_13': 'Menos de 13 años',
            'BETWEEN_13_AND_16': 'Entre 13 a 16 años',
            'BETWEEN_17_AND_24': 'Entre 17 a 24 años',
            'OVER_24': 'Más de 24 años'
        };

        const translatestudentAgeRanges = (ranges) => {
            return ranges.map(range => ({
                id: range.id,
                name: studentAgeRangeMapping[range.name] || range.name
            }));
        };





        const selectedCountryId = ref(null);
        const selectedStateId = ref(null);
        const selectedInstituteTypeId = ref(null);
        const selectedGenderId = ref(null);
        const selectedstudentAgeRangeId = ref(null);


        async function getCreationOptions() {
            const req = await store.dispatch("profile_creationOptions");
            creationOptions.value = req.data;
            country.value = req.data.country;
            state.value = req.data.state;
            gender.value = req.data.gender;
            instituteType.value = translateInstituteTypes(req.data.instituteType);
            studentAgeRange.value = translatestudentAgeRanges(req.data.studentAgeRange);
        }


        async function getProfile() {
            const req = await store.dispatch("profile_profileData", userId);
            profileData.value = req.data;
            profileDataLoaded.value = true;

            selectedGenderId.value = profileData.value.personalData.gender.id;
            selectedCountryId.value = profileData.value.personalData.country.id;
            selectedStateId.value = profileData.value.contactData.state.id;
            selectedInstituteTypeId.value = profileData.value.professionalData.instituteType.id;
            selectedstudentAgeRangeId.value = profileData.value.professionalData.studentAgeRange.id;
        }






        const submitPersonalDataForm = async () => {
            const payload = {
                firstName: profileData.value.personalData.firstName,
                lastName: profileData.value.personalData.lastName,
                dni: profileData.value.personalData.dni,
                country: {
                    id: selectedCountryId.value,
                    name: country.value.find(c => c.id === selectedCountryId.value).name
                },
                birthDate: profileData.value.personalData.birthDate,
                gender: {
                    id: selectedGenderId.value,
                    name: gender.value.find(g => g.id === selectedGenderId.value).name
                }
            };

            try {
                await store.dispatch("profile_personalData", { userId, payload })
                console.log('Profile personal data updated')
                isEditingPersonal.value = false;
                getProfile()
            } catch (error) {
                console.error(error)
                store.dispatch('notifications_create', { text: 'Ha ocurrido un error al intentar actualizar los datos personales' });
            }

        };


        const submitContactDataForm = async () => {
            const payload = {
                phoneNumber: profileData.value.contactData.phoneNumber,
                // state: {
                //     id: selectedStateId.value,
                //     name: state.value.find(s => s.id === selectedStateId.value).name
                // }
                state: null
            };
            try {
                await store.dispatch("profile_contactData", { userId, payload })
                console.log('Profile contact data updated')
                isEditingContact.value = false;
                getProfile()
            } catch (error) {
                console.error(error)
                store.dispatch('notifications_create', { text: 'Ha ocurrido un error al intentar actualizar los datos de contacto' });

            }
        };


        const submitProfessionalDataForm = async () => {
            const payload = {
                instituteType: {
                    id: selectedInstituteTypeId.value,
                    name: instituteType.value.find(it => it.id === selectedInstituteTypeId.value).name
                },
                studentsQuantity: parseInt(profileData.value.professionalData.studentsQuantity),
                studentAgeRange: {
                    id: selectedstudentAgeRangeId.value,
                    name: studentAgeRange.value.find(sr => sr.id === selectedstudentAgeRangeId.value).name
                }
            };
            try {
                await store.dispatch("profile_professionalData", { userId, payload })
                console.log('Profile professional data updated')
                isEditingProfessional.value = false;
                getProfile()
            } catch (error) {
                console.error(error)
                store.dispatch('notifications_create', { text: 'Ha ocurrido un error al intentar actualizar los datos profesionales' });
            }
        };




        onMounted(() => {
            getCreationOptions()
            getProfile()
        })
        
        return{
            studentAgeRangeMapping,
            instituteTypeMapping,
            profileData,
            profileDataLoaded,
            studentAgeRange,
            country,
            state,
            gender,
            instituteType,
            selectedData,
            getProfile,
            getCreationOptions,
            formatDate,
            creationOptions,
            selectedCountryId,
            selectedStateId,
            selectedInstituteTypeId,
            selectedGenderId,
            selectedstudentAgeRangeId,
            submitPersonalDataForm,
            submitContactDataForm,
            submitProfessionalDataForm,
            toggleEditPersonal,
            toggleEditContact,
            toggleEditProfessional,
            disableAllEdits,
            isEditingPersonal,
            isEditingContact,
            isEditingProfessional,
            profileImageSet,
            showPictureModal,
            profileImageURL,
            fileUploaded,
            deleteImagePreview,
            saveProfilePicture,
            getFile,
            userPlaceholderImage,
            dniMaxCharacters,
            checkDniCharacters,
            phoneMaxCharacters,
            checkPhoneCharacters
        }
    },
}
</script>
<style lang="scss" scoped>
@import '@/styles/main.scss';
@import '~vue-skeletor/dist/vue-skeletor.css';

.profile__container {
    --vc-nav-background-color: #fff;
    --vc-nav-width: 40px;
    background-color: #fff;
    padding: 30px 0;
    padding-top: 48px;
    width: 1328px;
    margin: 0 auto;
    display: flex;
    gap: 16px;
    @media screen and (max-width: 1400px){
        width: 992px;
    }
    @media screen and (max-width: 1100px){
        width: 656px;
    }
    @media screen and (max-width: 700px){
        width: 98%;
        flex-direction: column;
        gap: 48px;
        padding: 16px 24px 0;
    }

    .profile__container__data {
        display: flex;
        flex-direction: column;
        align-items: baseline;
        gap: 32px;
        width: 30%;
        @media screen and (max-width: 700px){
            width: 100%;
        }
        &__profile-image {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 16px;
            &__image {
                width: 120px;
                height: 120px;
                background: $green;
                border-radius: 120px;
                display: flex;
                align-items: center;
                justify-content: center;

                background-size: cover;
                background-position: center;

                &--set {
                    background-color: #fff;
                }

                &__name {
                    color: #fff;
                    font-size: 36px;
                    font-style: normal;
                    font-weight: 700;
                }
            }
            &__action {
                color: $green;
                font-size: 16px;
                font-weight: 600;
                cursor: pointer;
            }

            &__modal {
                width: 524px;

                @media (max-width: 980px) {
                    width: 100%;
                }

                h4 {
                    margin-bottom: 16px;
                }

                .modal__buttons {
                    justify-content: center;
                    gap: 24px;
                }

            }
        }

        &__profile-nav {
            &__navigation {
                display: flex;
                flex-direction: column;
                gap: 16px;
                &__item {
                    font-size: 16px;
                    font-weight: 600;
                    cursor: pointer;
                    &--selected {
                        font-weight: 800;
                    }
                }
            }
        }
    }

    .profile__container__info {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 32px;
        width: 70%;
        @media screen and (max-width: 700px){
            width: 100%;
        }

        &__filled {
            display: flex;
            flex-direction: column;
            gap: 32px;

            div {
                display: flex;
                flex-direction: column;
                gap: 8px;

                h3 {
                    font-size: 16px;
                    font-weight: 400;
                }
    
                span {
                    font-size: 16px;
                    font-weight: 700;
                }
            }

        }

        &__title {
            display: flex;
            gap: 32px;

            h2 {
                font-size: 20px;
                font-weight: 700;
            }
            span {
                font-size: 16px;
                font-weight: 600;
                color: $green;
                cursor: pointer;
                display: flex;
                align-items: center;
                gap: 8px;
            }
        }

        &__form {
            display: flex;
            flex-direction: column;
            gap: 32px;
            max-width: 340px;

            &__radio {
                display: flex;
                flex-direction: column;
                gap: 16px;

                h3 {
                    font-size: 13px;
                    font-weight: 700;
                    text-transform: uppercase;
                }


                div {
                    display: flex;
                    gap: 16px;

                    font-size: 13px;
                    font-weight: 600;
                }
            }

            &__selects {
                display: flex;
                flex-direction: column;
                gap: 32px;
                width: 100%;
            }

            .buttons {
                margin-top: 16px;
                display: flex;
                gap: 12px;
                button{
                    min-width: 160px;
                    height: 45px;
                    padding: 8px 16px;
                    border-radius: 20px;
                    font-size: 16px;
                    font-weight: 600;
                    letter-spacing: 1px;
                    border-radius: 100px;
                }
                .confirm{
                    background-color: $green;
                    color: #fff;
                }
                .cancel{
                    border: 1px solid $green;
                    color: $green;
                }
            }
        }
    }
    
}

</style>